/* RESPONSIBLE TEAM: team-standalone */

import type { RequestAccessData } from '../definitions';
import type Platform from '../../platform';

export default class GenericRequestAccessData implements RequestAccessData {
  private platform: Platform;

  constructor(platform: Platform) {
    this.platform = platform;
  }

  get platformUrl() {
    return undefined;
  }

  get platformName() {
    return this.platform.platformKey;
  }

  get imageUrl() {
    return '';
  }
}
